<template>
  <div class="office">
    <office-head placeholder="搜索门诊关键词" ref="head" @search="search" />
    <div class="my-wrap">
      <!-- 筛选相关 -->
      <div 
        class="filter"
        v-if="key == 'office' || key=='adult' || key=='children'" 
        @click="showFilter"
      >
        <van-icon name="filter-o" />
        <span>筛选</span>
      </div>
      <van-popover
        v-else
        v-model="showPopover"
        trigger="click"
        placement="bottom-start"
        :actions="actions"
        @select="onSelect"
      >
        <template #reference>
          <van-button type="info" plain size="small">{{ text }}</van-button>
        </template>
      </van-popover>
      <!-- 列表 -->
      <van-list
        ref="list"
        v-if="location.lon"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div 
          class="my-card my-tags" 
          v-for="(item, index) in list" 
          :key="index" 
          @click="pickOffice(item)"
        >
          <div class="row-top">{{ item.fullName }}</div>
          <div class="row-mid">
            <van-tag 
              plain 
              type="primary"
              v-for="type in item.types"
              :key="type"
            >
              {{ type }}
            </van-tag>
            <van-tag plain type="primary" v-if="item.isTwentyFourHours">24H</van-tag>
          </div>
          <div class="row-btm">
            <div class="left">
              <img src="@/assets/imgs/map.png">
              <span class="van-ellipsis">{{ item.registerAddress }}</span>
            </div>
            <div class="right">{{ item.distance }}km</div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 右侧弹出 -->
    <office-filter ref="filter" @confirm="confirm" />
  </div>
</template>

<script>
import OfficeHead from 'components/OfficeHead'
import OfficeFilter from './OfficeFilter'
import getLocation from 'utils/getLocation'
import { convertToArrTxt } from 'utils/handlePovType'
import { fetchOffice } from 'api/office'
import { mapState } from 'vuex'

export default {
  components: {
    OfficeHead,
    OfficeFilter
  },
  computed: {
    ...mapState(['key'])
  },
  data() {
    return {
      showPopover: false,
      text: '是否24H门诊',
      actions: [
        { text: '是', value: true },
        { text: '否', value: false },
        { text: '全部', value: '' },
      ],
      list: [],
      loading: false,
      finished: false,
      pages: 0,
      // 以下为接口参数相关
      povType: '',
      keyWords: '',
      isTwentyFourHours: '',
      distance: '',
      location: {
        lon: '',
        lat: ''
      },
      page: {
        current: 0,
        size: 20
      },
    }
  },
  mounted() {
    // 从首页搜索框进来时的一些处理
    const { keyWords } = this.$route.query
    if (keyWords) {
      this.$refs.head.setValue(keyWords)
      this.keyWords = keyWords
    }

    switch (this.key) {
      case 'rabies':
        this.povType = 4
        break;
      case 'xg':
        this.povType = 5
        break;
      case 'flu':
        this.povType = 6
        break;
    }
    this.handleLocation()
  },
  methods: {
    // 获取定位
    handleLocation() {
      if (process.env.NODE_ENV == 'production') {
        // 生产环境调用
        getLocation().then(res => {
          this.location.lon = res.longitude
          this.location.lat = res.latitude
        })
      } else {
        // 本地调试
        this.location.lon = 117.1241210
        this.location.lat = 31.83
      }
    },
    // 获取门诊列表
    getList() {
      const params = {
        ...this.location,
        ...this.page,
        povType: this.povType,
        keyWords: this.keyWords,
        isTwentyFourHours: this.isTwentyFourHours,
        distance: this.distance
      }
      fetchOffice(params).then(res => {
        this.loading = false
        let list = res.data.records
        list.forEach(v => {
          if (v.povType) {
            v.types = convertToArrTxt(v.povType)
          }
        })
        this.list = [...this.list, ...list]
        // 分页逻辑处理
        this.pages = res.data.pages
        if (this.page.current >= this.pages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    },
    // 上拉
    onLoad() {
      this.page.current ++
      this.getList()
    },
    // 搜索
    search(value) {
      this.list = []
      this.page.current = 1
      this.distance = ''
      this.isTwentyFourHours = ''
      if (this.key == 'office' || this.key == 'adult' || this.key == 'children') {
        this.povType = ''
      }

      this.keyWords = value || ''
      this.text = '是否24H门诊'
      this.getList()
    },
    showFilter() {
      this.$refs.filter.open()
    },
    // 筛选
    confirm(value) {
      this.list = []
      this.page.current = 1
      this.keyWords = ''
      this.$refs.head.clear()

      this.distance = value.distance
      this.povType = value.type
      this.isTwentyFourHours = value.time
      this.getList()
    },
    onSelect(action) {
      if (this.text == action.text) return
      this.text = action.text

      this.list = []
      this.page.current = 1
      this.keyWords = ''
      this.$refs.head.clear()
      this.isTwentyFourHours = action.value
      this.getList()
    },
    // 选中
    pickOffice(item) {
      if (this.key != 'office') {
        this.$store.commit('setOfficeCopy', item)
        this.$store.commit('setVacc', null)
        this.$router.push('/appointment')
      } else {
        this.$store.commit('setOffice', item)
        this.$router.push('/office-detail')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my-wrap {
  .filter {
    width: 63px;
    height: 25px;
    background: #fff;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 300;
    color: #757575;
    opacity: .9;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-icon {
      margin-right: 3px;
    }
  }
  .my-card {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.van-button {
  width: 95px;
}
.van-list {
  margin-top: 13px;
}
</style>